import {Button} from '@/components/ui/button/Button'
import styled, {css} from 'styled-components'
import {InputText} from '../input-text/InputText'

export const StyledInputDateCalendarButton = styled(Button)<{$hasError: boolean}>(
    ({theme: {palette}, $hasError}) => css`
        border-radius: 8px 0 0 8px;
        outline: 1px solid ${$hasError ? palette.danger['300'] : palette.neutral['300']};
        &:disabled {
            background-color: ${palette.neutral['100']};
            box-shadow: none;
        }
    `
)

export const StyledInputDateText = styled(InputText)(
    () => css`
        border-radius: 0 8px 8px 0;
        & div {
            border-radius: 0 8px 8px 0;
        }
    `
)
